var _this = this;
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import axios from 'axios';
import store from '@/store';
import request from '@/utils/request';
// 检验文件是否是图片类型
export var checkFileIsImage = function checkFileIsImage(file) {
  var fileType = file.type;
  return fileType.indexOf('image') !== -1;
};
export var checkFileExtension = function checkFileExtension(file, extensions) {
  var suffix = getFileExtension(file);
  return !!extensions.find(function (item) {
    return suffix === item;
  });
};
export var getFileExtension = function getFileExtension(file) {
  var suffixIndex = file.name.lastIndexOf('.');
  var suffix = suffixIndex === -1 ? '' : file.name.substring(suffixIndex + 1);
  return suffix.toLowerCase();
};
// 检验文件大小
export var checkFileSize = function checkFileSize(file, size) {
  var fileSize = file.size / 1024 / 1024;
  return fileSize <= size;
};
// 检验图片宽高
export var checkFileWidthHeight = function checkFileWidthHeight(file, width, height) {
  return new Promise(function (resolve) {
    var reader = new FileReader();
    reader.onload = function (e) {
      var img = new Image();
      img.onload = function () {
        if (img.width !== width || img.height !== height) {
          resolve(false);
        } else {
          resolve(true);
        }
      };
      img.onerror = function () {
        _this.$message.error('图片加载失败，请重试');
        resolve(false);
      };
      img.src = e.target.result;
    };
    reader.readAsDataURL(file);
  });
};
// 上传
export var uploadFile = function uploadFile(file, onProgress, linkUrl) {
  return getUploadToken(linkUrl).then(function (responseData) {
    var uploadInfo = responseData.data;
    var formData = new FormData();
    formData.append('name', file.name);
    var name = calculate_object_name(file);
    var time = getTime();
    if (linkUrl && linkUrl.config == '/cardmake/image/upload/config') {
      // 获取文件扩展名
      var fileExtension = getFileExtension(file);
      // 检查是否是需要特殊处理的设计稿格式
      var isDesignFile = ['psd', 'pdf', 'ai'].includes(fileExtension);
      if (isDesignFile) {
        // 设计稿文件：使用原文件名 + 时间戳,去掉空格和 . / * + # % & 等特殊符号
        var originalNameWithoutExt = file.name.substring(0, file.name.lastIndexOf('.')).replace(/[\s./&+#%*?'"\\$(){}[\]<>|:;@!^~`]/g, '');
        name = "".concat(originalNameWithoutExt, "_").concat(Date.now(), ".").concat(fileExtension);
        var key = "".concat(uploadInfo.dir, "/").concat(time, "/").concat(name);
        formData.append('key', key);
      } else {
        // 图片文件：保持原逻辑
        formData.append('key', uploadInfo.dir + '/' + time + '/' + name);
      }
    } else {
      formData.append('key', uploadInfo.dir + '/' + time + '/' + name);
    }
    var url = uploadInfo.dir + '/' + time + '/' + name;
    formData.append('policy', uploadInfo.policy);
    formData.append('OSSAccessKeyId', uploadInfo.accessid);
    formData.append('success_action_status', 200);
    formData.append('signature', uploadInfo.signature);
    formData.append('file', file);
    // 创建自定义axios实例，覆盖全局timeout配置
    var uploadAxios = axios.create({
      timeout: 3 * 60 * 1000 // 3分钟超时
    });
    return uploadAxios.post(uploadInfo.host, formData, {
      key: url,
      onUploadProgress: function onUploadProgress(progressEvent) {
        if (onProgress && progressEvent.total) {
          var percentCompleted = Math.round(progressEvent.loaded * 100 / progressEvent.total);
          onProgress(percentCompleted);
        }
      }
    });
  });
};
export function getUploadToken(linkUrl, params) {
  var configUrl = linkUrl && linkUrl.config ? linkUrl.config : store.state.app.linkUrl.config;
  return request({
    // url: '/package/banner/upload/config',
    url: configUrl,
    method: 'get',
    params: params
  });
}
export function getTime() {
  var time = new Date();
  var y = time.getFullYear();
  var m = time.getMonth() + 1;
  var d = time.getDate();
  return y + add0(m) + add0(d);
}
export function add0(m) {
  return m < 10 ? '0' + m : m;
}
var g_object_name = '';
function get_suffix(file) {
  console.log(file);
  var suffixIndex = file.name.lastIndexOf('.');
  var suffix = suffixIndex === -1 ? '' : file.name.substring(suffixIndex + 1);
  return '.' + suffix.toLowerCase();
}
function calculate_object_name(filename) {
  console.log();
  var suffix;
  suffix = get_suffix(filename);
  g_object_name = random_string(10) + suffix;
  return g_object_name;
}
function random_string(len) {
  len = len || 32;
  var chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
  var maxPos = chars.length;
  var pwd = '';
  for (var i = 0; i < len; i++) {
    pwd += chars.charAt(Math.floor(Math.random() * maxPos));
  }
  return pwd;
}